import React from "react";
import { observer } from "mobx-react";

import { BetBuilderPick } from "@data-types/bet-booster/BetBuilderPicks";
import { useRootAppStore } from "@hooks";

import { BetBuilderPicksOfferTips } from "../BetBuilderPicksOfferTips";
import { QuickPlayPopupsTeams } from "@features/quick-play/mobile/common/QuickPlayPopupsTeams";
import QuickPlayEventResultAndTime from "@features/quick-play/shared/QuickPlayEventResultAndTime";

export default observer(function BetBuilderPicksPopupBody(props: {
	BBPick: BetBuilderPick;
}) {
	const rootStore = useRootAppStore();
	const event =
		rootStore.quickPlayStore.betBoosterStore.eventsResultHubStore.getEvent(
			props.BBPick.eventId
		);

	return (
		<div className="card--bbp">
			<div className="card__body card--qp__body card--bbp__body">
				<QuickPlayEventResultAndTime
					event={event}
					startTime={props.BBPick.startTime}
				/>

				<div className="card--qp__event card--bbp__event">
					<QuickPlayPopupsTeams
						sportData={props.BBPick.multiOffers[0].sportData}
						eventId={props.BBPick.eventId}
						isBetBuilder
					/>
				</div>

				<div className="card--qp__offer card--bbp__offer">
					<BetBuilderPicksOfferTips
						multiOffers={props.BBPick.multiOffers}
						isPopup
						isWrapped={true}
					/>
				</div>
			</div>
		</div>
	);
});
